import Vue from 'vue';
import App from './app.vue';
import { router } from './router';
import store from './store';
import VueRemote from 'baimahu/vue-remote';
import antd from './global/antd-config';
import axios from 'axios';
// import { Cascader } from 'element-ui';
import ElCascader from 'element-ui/lib/cascader';
import 'element-ui/lib/theme-chalk/index.css';

const { VUE_APP_CSRF: CSRF } = process.env;
Vue.config.productionTip = false;
Vue.use(VueRemote);
import { Radio, DatePicker, message } from 'ant-design-vue';
Vue.use(antd);
Vue.use(Radio);
Vue.use(DatePicker);
// Vue.component(Cascader.name, Cascader);
Vue.component('el-cascader', ElCascader);
axios.defaults.withCredentials = true;
axios.interceptors.request.use((config) => {
  config.xsrfHeaderName = 'X-CSRF-TOKEN';
  config.xsrfCookieName = CSRF;
  return config;
});

axios.interceptors.response.use((response) => {
  if (response.data.status === 504) {
    message.error(response.data.message);
    return Promise.reject();
  }
  return response;
});

Vue.prototype.$axios = axios;

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
